import request from '@/utils/request'

let Platform_introApi = {

  /*平台简介列表*/
  list(data) {
    return request._post('/shop/plus.platform_intro.Index/index', data);
},
/*添加平台简介*/
add(data) {
    return request._post('/shop/plus.platform_intro.Index/add', data);
},
/*修改平台简介*/
edit(data) {
    return request._post('/shop/plus.platform_intro.Index/edit', data);
},
/*删除平台简介*/
del(data) {
    return request._post('/shop/plus.platform_intro.Index/del', data);
},
/*平台简介详情*/
detail(data) {
  return request._post('/shop/plus.platform_intro.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.platform_intro.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.platform_intro.Setting/getSetting', data, errorback);
    },
}
export default Platform_introApi;



// WEBPACK FOOTER //
// ./src/api/platform_intro.js